import { getLocale } from '@/core/shared'

export function initDatepicker (contextSelector) {
	$(function () {
		$(contextSelector ? (contextSelector + ' .datepicker') : '.datepicker').datepicker({
			format: 'yyyy-mm-dd',
			weekStart: 1,
			todayBtn: 'linked',
			autoclose: true,
			language: getLocale()
		})
	})
}

export function initRangeDatepicker () {
	$(function () {
		$('.input-daterange').datepicker({
			format: 'yyyy-mm-dd',
			weekStart: 1,
			todayBtn: 'linked',
			clearBtn: true,
			autoclose: true,
			language: getLocale()
		})
	})
}
